import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {ConfirmActionComponent} from "../../shared/component/confirm-action/confirm-action.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

declare let moment: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;

    week: any;
    currentUser: any;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button

    constructor(private modalService: NgbModal, public menu: MenuService, private authenticationService: AuthenticationService,
                public settings: SettingsService, public injector: Injector) {

        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
        this.currentWeek();
    }

    ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.isNavSearchVisible = false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });

    }

    logout() {
        const modalRef = this.modalService.open(ConfirmActionComponent);
        modalRef.componentInstance.message = $localize`Voulez-vous vraiment faire un logout ?`;
        modalRef.componentInstance.info = $localize ``;
        modalRef.result.then((res) => {
            if (res === true) {
                this.blockUI.start('Logout');
                this.authenticationService.logout()
                    .subscribe(data => {
                        // remove user from local storage to log user out
                        localStorage.removeItem('token');
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('tokenExp');
                        this.blockUI.stop();
                        this.router.navigate(['/page/login']);
                    }, err => {
                        this.blockUI.stop();
                    });
            }
        });
    }

    setNavSearchVisible(stat: boolean) {
      // console.log(stat);
      this.isNavSearchVisible = stat;
    }

    isCollapsedText() {
      return this.settings.getLayoutSetting('isCollapsedText');
    }

    navigateTo(event, link) {
      //event.preventDefault();
      this.router.navigate([link]);
    }

    toggleCollapsedSideabar() {
      this.settings.toggleLayoutSetting('isCollapsed');
    }

    pause() {
        const modalRef = this.modalService.open(ConfirmActionComponent);
        modalRef.componentInstance.message = $localize`Voulez-vous vraiment faire une pause ?`;
        modalRef.componentInstance.info = $localize ``;
        modalRef.result.then((res) => {
            if (res === true) {

            }
        });
    }

    currentWeek() {
        this.week = moment(new Date()).isoWeek();
    }
}
